module.exports = __webpack_public_path__ + "static/media/47ch.84b14c2e.pdf";